import { createUseStyles } from 'react-jss'

export const style = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  splitChartContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > *': {
      marginLeft: 24
    },
    '& > *:first-child': {
      marginLeft: -12
    }
  },
  dataSetNavigator: {
    display: 'flex'
  },
  selectWrapper: {
    display: 'flex',
    width: 500,
    margin: 'auto',
    border: '1px solid black'
  },
  select: {
    width: '100%',
    border: 'none',
    backgroundColor: 'rgba(255,255,255,0)',
    fontSize: 14,
    fontFamily: 'barlow, sans-serif'
  },
  chevron: {
    margin: '0 10px',
    width: 15,
    cursor: 'pointer'
  }
}

export const useStyles = createUseStyles(style)
